export const FIRST_AXES_VIEW = 'first-axes-view';
export const SECOND_AXES_VIEW = 'second-axes-view';
